<template>
  <div class="wrap">
    <!-- <div class="left">
      <div class="title">
        <span class="count">设备总数</span>
        <span>xxxx</span>
      </div>
      <div class="message-wrap">
        <div class="message">
          <el-row class="top">
            <el-col :span="12">设备名称xxx</el-col>
            <el-col :span="12" class="num">xxxx</el-col>
          </el-row>
          <el-row class="detail">
            <el-col :span="11" v-for="(val, key, index) in detailData" :key="index" :offset="2">
              <el-col :span="6">{{key}}</el-col>
              <el-col :span="6" class="num" >{{val}}台</el-col>
            </el-col>
          </el-row>
        </div>
      </div>
    </div> -->
    <div class="right">
      <div class="echart-wrap">

        <div class="title">
          <div>
            <el-tag
            class="tag"
            v-for="taskId in Object.keys(compareTask)"
            :key="taskId"
            @close="closeTag(taskId)"
            closable
            type="">
            {{compareTask[taskId].taskName}}
          </el-tag>
          </div>
          <!-- 时间选择 -->
          <div class="function-wrap">
            <!-- <el-button type="" icon="el-icon-document" @click="exportData" :disabled="!hasData || loading" :loading="loading">{{loading?'导出中':'导出表格'}}</el-button> -->
            <div class="dateWrap">
              <el-date-picker
                v-model="showDate"
                type="datetimerange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                change="changeDate"
                :clearable="false"
                align="right">
              </el-date-picker>
            </div>
            <!-- 年月切换 -->
            <el-button-group>
              <el-button @click="periodClick(3)" :type="initQueryParams.params.period === 3 ? 'primary':''">月</el-button>
              <el-button @click="periodClick(2)"  v-if="minPeroid <= 2" :type="initQueryParams.params.period === 2 ? 'primary':''">日</el-button>
              <el-button @click="periodClick(1)"  v-if="minPeroid <= 1" :type="initQueryParams.params.period === 1 ? 'primary':''">时</el-button>
              <el-button @click="periodClick(0)" v-if="minPeroid <= 0" :type="initQueryParams.params.period === 0 ? 'primary':''">分</el-button>
            </el-button-group>
          </div>
        </div>
        <div class="echart">
          <compareLineCharts
            @next-page="nextPage"
            v-if="chartData"
            :refresh="refresh"
            :data="chartData"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import compareLineCharts from './compareLineCharts'
// import BarCharts from './barCharts'
import { dateHelper, dataFormat } from '@/utils'

// import helper from '@/utils/helper.js'
import { eventBus } from '@/utils/eventBus'
import { mapData } from '@/api/dataStatistics'
import { thingModel } from '@/api/deviceManagement'
export default {
  props: ['taskId', 'taskDetail', 'centerTitle', 'compareTask'],
  components: {
    compareLineCharts
    // SiderCharts,
    // BarCharts
  },
  data () {
    const dateArr = dateHelper.getRecentYear()
    return {
      loading: false, // 表示是否正正在导出表格
      detailData: {
        online: '27',
        a1asdas: '0',
        basdsa: '0',
        csadsa: '0'
      },
      test: {
        aa: 88,
        bb: 77
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }],
        disabledDate (time) {
          const dateArr = dateHelper.getRecentYear('number')
          return (time.getTime() > dateArr[1] || time.getTime() < dateArr[0] - 8.64e6)
        }
      },
      dateParams: {
        beginTime: '',
        endTime: '',
        period: '' // 默认为2按日展示、3按月展示
      },
      showDate: [dateArr[0], dateArr[1]],
      // 切换tab的初始请求参数，不改动，除了taskId，其他不动
      // 然后每个子组件维护自己的相应的请求参数的变动，将请求参数带过来
      initQueryParams: {
        params: {
          // taskId: this.taskId,
          beginTime: '',
          endTime: '',
          period: 0,
          // period 和way的对应
          // 3 2 1 0
          //   1 2 3
          // period: this.taskDetail.way !== '' && !isNaN(this.taskDetail.way)
          //   ? this.taskDetail.way === 1
          //     ? 2
          //     : this.taskDetail.way === 2
          //       ? 1
          //       : 0
          //   : 3,
          // this.taskDetail.way !== '' && !isNaN(this.taskDetail.way) ? this.taskDetail.way : 2, // 2按日// period为3默认按月汇总
          pageNumber: 1,
          pageSize: 1440
        }
      },
      chartData: null,
      propertyData: {}, // 用于保存各个任务不同属性对应得图表数据
      total: 0,
      isRequest: false,
      showLineChart: true,
      refresh: false, // 用于请求完数据刷新图表
      thingModel: null, // 物模型数据
      title: '',
      groupName: '', // 用于保存分组名
      // 统计函数列表
      performTypeList: {
        0: '总数',
        1: '最大值',
        2: '最小值',
        3: '求和',
        4: '平均'
      },
      minPeroid: 0// 所有任务可支持得共有最大粒度
    }
  },
  created () {
    this.getCompareChartData()
    // this.initMapData()
    eventBus.$on('getCompareChartData', this.getCompareChartData)
  },
  methods: {
    closeTag (taskId) {
      this.$delete(this.compareTask, taskId)
      this.initMapData()
    },
    getGroupItem (task, field) {
      // console.log('调用了getGroupItem')
      // 获取分组对象
      const typeList = {
        1: 'properties',
        2: 'events',
        3: 'services'
      }
      let list = ''
      if (task.type.toString() === '1') { // 属性
        list = task.thingModel[typeList[task.type]]
      } else {
        list = task.thingModel[typeList[task.type]].outputData
      }
      // console.log('list:', list)
      // console.log('this.taskDetail:', task)
      let fieldList
      if (field) {
        fieldList = field.split('.')
      } else {
        fieldList = task.field.split('.')
      }
      const getItem = function (index, list) {
        let item = ''
        let i = 0
        while (i < list.length) {
          if (list[i].identifier === fieldList[index]) {
            item = list[i]
            // console.log('找到了item：', item)
            if (index < fieldList.length && item.dataType.type === 'struct') {
              getItem(index++, item.dataType.specs)
            } else if (index < fieldList.length && item.dataType.type === 'array') {
              if (item.dataType.specs.item.type === 'struct') {
                getItem(index++, item.dataType.specs.item.specs)
              } else {
                return item
                // return item.dataType.specs
              }
            } else {
              return item
              // return item.dataType.specs
            }
            break
          }
          i++
        }
      }
      const groupName = getItem(0, list)
      return groupName
    },
    async getThingModel () {
      // 组装一个请求列表数组
      const request = []
      Object.keys(this.compareTask).forEach(key => {
        const task = this.compareTask[key]
        task.error = 0
        request.push(task)
      })
      return new Promise((resolve, reject) => {
        const len = request.length
        let counter = 0
        let isStop = false
        const start = async () => {
          if (isStop) {
            return
          }
          const task = request.shift()
          if (task) {
            try {
              const params = {
                productKey: task.productKey
              }
              // console.log('getThingModel params:', params)
              await thingModel(params).then(res => {
                res = res.data
                // console.log('外层物模型数据：', res)
                task.thingModel = res.data.thingModel
                const groupItem = this.getGroupItem(task)
                task.title = groupItem.name
                task.groupName = groupItem.dataType.specs
                // console.log('groupName:', task.groupName)
              }).catch((e) => {
                if (task.error < 3) {
                  task.error++
                  request.unshift(task)
                  start()
                } else {
                  // 错误三次
                  isStop = true
                  reject(e)
                }
              })
              if (counter === len - 1) {
                // console.log('所有物模型数据获取结束：', this.compareTask)
                // 最后一个任务
                resolve()
              } else {
                counter++
                // 启动下一个任务,如果关闭了就不再继续
                start()
              }
            } catch (e) {
              if (task.error < 3) {
                task.error++
                request.unshift(task)
                start()
              } else {
                // 错误三次
                isStop = true
                reject(e)
              }
            }
          }
        }
        while (request.length > 0) {
          start()
        }
      })
    },
    changeDate (date) {
      // console.log('获取的数据：', date)
    },
    periodClick (period) {
      console.log('period:', period)
      this.initQueryParams.params.pageNumber = 1
      this.initQueryParams.params.period = period
      const params = this.initQueryParams.params
      // console.log('params:', params)
      this.getMapData(params)
      // this.dateParams.period = period
      // eventBus.$emit('query-chart-data', { params: this.dateParams })
    },
    async getCompareChartData (addTask) {
      if (addTask) {
        Object.assign(this.compareTask, addTask)
      }
      // 获取物模型数据
      await this.getThingModel()
      // 获取任务数据
      this.initMapData()
    },
    initMapData () {
      this.initQueryParams.params.pageNumber = 1// 每次请求页码重置为1
      console.log('this.this.showDate:', this.showDate)
      if (this.showDate && this.showDate.length > 0) {
        // 对请求的起止时间进行更新
        this.initQueryParams.params.beginTime = dataFormat(this.showDate[0])
        this.initQueryParams.params.endTime = dataFormat(this.showDate[1])
      }

      let period = 0
      console.log('初始化前的this.compareTask：', this.compareTask)
      Object.keys(this.compareTask).forEach(key => {
        const task = this.compareTask[key]
        task.chartData = { xData: [], yData: [], x2y: {}, ySortData: [] }
        const taskPeiod = task.way !== '' && !isNaN(task.way)
          ? task.way === 1
            ? 2
            : task.way === 2
              ? 1
              : 0
          : 3
          // 循环得出每个任务得最小粒度，取最大值
          // 得出的就所有任务共有的最小粒度
        taskPeiod > period ? period = taskPeiod : ''
      })
      console.log('初始化后得this.compareTask：', this.compareTask)
      this.minPeroid = period
      console.log('最小粒度minPeroid：', this.minPeroid)
      this.initQueryParams.params.period = this.minPeroid
      const params = this.initQueryParams.params
      console.log('获取的params：', JSON.stringify(params))
      this.getMapData(params)
    },
    // 获取折线图和条形图数据
    async getMapData (params, nextPage) {
      console.log('this.isRequest:', this.isRequest)
      if (this.isRequest) {
        return
      }
      if (!nextPage) {
        this.propertyData = {}
        Object.keys(this.compareTask).forEach(key => {
          try {
            delete this.compareTask[key].total
          } catch (e) {}
        })
      }
      this.isRequest = true
      console.log('获取折线图和条形图数据:params:', JSON.stringify(params))
      const that = this
      // 组装一个请求列表数组
      const request = []
      console.log('this.compareTask:', this.compareTask)
      Object.keys(this.compareTask).forEach(key => {
        const task = this.compareTask[key]
        task.error = 0
        if (nextPage && params.pageNumber <= Math.ceil(task.total / params.pageSize)) { // 如果是请求下一页，就要判断此任务请求得总页数是否超过
          request.push(task)
        } else {
          request.push(task)
        }
      })
      return new Promise((resolve, reject) => {
        const len = request.length
        let counter = 0
        let isStop = false
        let total = 0
        const start = async () => {
          if (isStop) {
            return
          }
          const task = request.shift()
          // x2y用于建立x和y值得对应
          const requestParams = Object.assign({}, params)
          if (task) {
            const chartData = nextPage ? task.chartData : { xData: [], yData: [], x2y: {}, ySortData: [] }
            Object.assign(requestParams, {
              taskId: task.taskId
            })
            // if (isNaN(requestParams.period) && requestParams.period !== '') {
            //   requestParams.period = period
            // }
            if (task.total === undefined || Math.ceil(task.total / params.pageSize) >= params.pageNumber) {
              try {
                await mapData({ params: requestParams }).then(res => {
                  if (res.data.data) {
                    console.log('请求的params', requestParams)
                    console.log('返回数据：', res.data)
                    console.log('requestParams.pageNumber:', requestParams.pageNumber)

                    let taskTotal = 0
                    const record = res.data.data.list ? res.data.data.list : []
                    record.forEach((propertyItem, index) => {
                      if (!propertyItem) {
                        return
                      }
                      propertyItem.recordCount > taskTotal ? taskTotal = propertyItem.recordCount : ''// 取最大的total
                      const groupName = that.getGroupItem(task, propertyItem.identifier)
                      !that.propertyData[task.taskId + '-' + propertyItem.identifier] ? that.propertyData[task.taskId + '-' + propertyItem.identifier] = {
                        xData: [],
                        x2y: {},
                        ySortData: [],
                        groupName: groupName,
                        performType: that.performTypeList[propertyItem.performType],
                        taskName: task.taskName
                      } : ''

                      // 用于保存每个属性对应每页的数据，方便往头部插入数据
                      const pageCharData = {
                        xData: [],
                        yData: []
                      }

                      propertyItem.recordLists.forEach((item, index) => {
                      // 数据先给最后一页的数据
                      // 上一页第一条数据，可能与下一页的最后一条数据是同一个时间的，需要做比对处理处理
                      // const len = chartData.xData.length
                        if (index === propertyItem.recordLists.length - 1 && chartData.xData.length > 0 && chartData.xData[0] === item.recordTime) {
                        // 有重复日期的天数
                        // xData不需要push，修改yData的数据
                          const startValue = parseFloat(chartData.yData[0])
                          let targetValue
                          if (item.performType === 0 || item.performType === 3) { // 总数或者求和函数，累加
                            targetValue = startValue + item.count
                          } else if (item.performType === 1) { // 最大值函数，取最大
                            targetValue = startValue > item.count ? startValue : item.count
                          } else if (item.performType === 2) { // 最小值函数，取最小
                            targetValue = startValue < item.count ? startValue : item.count
                          } else if (item.performType === 4) { // 平均函数，取两数平均值
                            targetValue = (startValue + item.count) / 2
                          }
                          // that.propertyData[propertyItem.identifier].yData[0] = targetValue
                          that.propertyData[task.taskId + '-' + propertyItem.identifier].x2y[dataFormat(item.recordTime)] = targetValue
                        // chartData.yData[0] = targetValue
                        } else {
                          pageCharData.xData.push(dataFormat(item.recordTime))
                          that.propertyData[task.taskId + '-' + propertyItem.identifier].x2y[dataFormat(item.recordTime)] = item.count
                        // chartData.xData.unshift(dataFormat(item.recordTime))
                        // chartData.yData.unshift(item.count)
                        }
                      })
                      // 往头部追加数据，xData后面再做去重处理
                      that.propertyData[task.taskId + '-' + propertyItem.identifier].xData.unshift(...pageCharData.xData)
                    })

                    task.total = taskTotal
                    if (task.total > total) {
                      total = task.total
                    }
                  }
                }, e => {
                  if (task.error < 3) {
                    task.error++
                    request.unshift(task)
                    start()
                  } else {
                  // 错误三次
                    isStop = true
                    reject(e)
                  }
                })
                if (counter === len - 1) {
                // that.refresh = !that.refresh
                  that.isRequest = false
                  console.log('所有任务数据获取结束：', this.compareTask)
                  this.total = total
                  this.sortData()// 整理数组
                  // 最后一个任务
                  resolve()
                } else {
                  counter++
                  // 启动下一个任务,如果关闭了就不再继续
                  start()
                }
              } catch (e) {
                if (task.error < 3) {
                  task.error++
                  request.unshift(task)
                  start()
                } else {
                // 错误三次
                  isStop = true
                  reject(e)
                }
              }
            } else {
              // 下一个任务
              if (counter === len - 1) {
                // that.refresh = !that.refresh
                that.isRequest = false
                console.log('所有任务数据获取结束：', this.compareTask)
                this.sortData()// 整理数组
                // 最后一个任务
                resolve()
              } else {
                counter++
                // 启动下一个任务,如果关闭了就不再继续
                start()
              }
            }
          }
        }

        while (request.length > 0) {
          start()
        }
      })
    },
    sortData () {
      let xData = new Set()
      console.log('sorDATA-this.propertyData:', this.propertyData)
      Object.keys(this.propertyData).forEach(key => {
        // xData.add(...this.compareTask[key].chartData.xData)
        xData = new Set([...xData, ...this.propertyData[key].xData])
        // 每次排序都是重新开始排序，需要把ySortData 重新清空
        this.propertyData[key].ySortData = []
      })
      xData = [...xData]
      // 大大小排序时间
      xData.sort((a, b) => {
        return new Date(a).getTime() - new Date(b).getTime()
      })
      // console.log('xData:', xData)
      const that = this
      // 从新给yData赋值
      xData.forEach(timeKey => {
        Object.keys(that.propertyData).forEach(key => {
          const value = that.propertyData[key].x2y[timeKey]
          if (value || !isNaN(value)) {
            that.propertyData[key].ySortData.push(value)
          } else {
            that.propertyData[key].ySortData.push('')
          }
        })
      })
      // @todo这一步有bug
      // 组装成图表需要得数据
      const chartData = { xData: xData, series: [] }
      Object.keys(that.propertyData).forEach(key => {
        const yData = that.propertyData[key].ySortData
        const name = that.propertyData[key].taskName + '-' + that.propertyData[key].groupName.name + '-' + that.propertyData[key].performType
        const item = {
          name: name,
          type: 'line',
          data: yData
        }
        chartData.series.push(item)
      })
      // Object.assign(this.chartData, chartData)
      this.chartData = chartData
      console.log('this.chartData8:', this.chartData)
      this.refresh = !this.refresh
      // console.log('that.compareTask:', that.compareTask)
    },
    nextPage () {
      // console.log('this.total:', this.total)
      if (this.initQueryParams.params.pageNumber < (this.total / this.initQueryParams.params.pageSize)) {
        // console.log('this.isRequest:', this.isRequest)
        if (this.isRequest === true) {
          return
        }
        this.initQueryParams.params.pageNumber++
        const params = this.initQueryParams.params
        this.getMapData(params, true)
      } else {
        // this.$message({
        //   dangerouslyUseHTMLString: true,
        //   showClose: true,
        //   message: '所有数据已加载完毕',
        //   type: 'success'
        // })
      }
    }
  },
  computed: {
    hasData () {
      return (this.chartData && this.chartData.xData && this.chartData.xData.length > 0)
    }
  },
  watch: {
    compareTask () {
      console.log('compareTask变化了')
      // this.getCompareChartData()
    },
    showDate () {
      // console.log('this.showDate变化了:', this.showDate)
      // 监听到日期变化后，去重新请求数据
      if (this.showDate) { // 点击清除按钮时候绑定的dateSel为null
        this.initQueryParams.params.pageNumber = 1// 每次请求页码重置为1
        this.initQueryParams.params.beginTime = dataFormat(this.showDate[0])
        this.initQueryParams.params.endTime = dataFormat(this.showDate[1])
        const params = this.initQueryParams.params
        this.getMapData(params)
        // eventBus.$emit('query-chart-data', { params: this.dateParams, data: this.data })
      }
    },
    'dateParams.period' () {
      // console.log('period变化了')
      eventBus.$emit('query-chart-data', { dateParams: this.dateParams, data: this.data })
    },
    taskId () {
      // console.log('taskId变换了：', this.taskId)
    }

  }
}
</script>

<style lang='less' scoped>
  .el-col-11{
    display: flex;
    justify-content: space-between;
  }
  .el-col-offset-2:nth-child(2n+1){
    margin-left: 0 !important;
  }
  .wrap{
    display: flex;
    justify-content: space-between;
    height: 600px;
    .left{
      background: #D5D5D5;
      width: 24%;
      border: 1px solid#F7F7F7;
      .title{
        display: flex;
        font-size: 20px;
        padding: 0 10px;
        justify-content: space-between;
        line-height: 50px;
        border-bottom: 1px solid#F7F7F7;;
      }
      .message-wrap{
        padding: 15px 10px;
        .message{
          padding: 15px 10px;
          background: white;
          .top{
            margin-bottom: 20px;
            .num{
              text-align: right;
            }
          }
          .detail{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .num{
              text-align: right;
            }
          }
        }
      }
    }
    .right{
      // background: #D5D5D5;
     // width: 75.4%;
      // border: 1px solid#F7F7F7;
      width:100%;
      padding: 20px 0px 0px 10px;
      .echart-wrap{
        background: white;
        height: 540px;
        // overflow: hidden;
        .title{
          padding: 10px 10px 0;
          font-size: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .function-wrap{
            display: flex;
            justify-content: space-between;
            .dateWrap{
              margin-right: 20px;
              margin-left: 20px;
            }
          }
        }
        .echart{
          padding-top: 20px;
          height: 450px;
          width: 100%;
        }
      }
    }
    .tag{
        margin-right: 5px;
        margin-top: 5px;
      }
  }
</style>
